import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1be1810a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-and-buttons" }
const _hoisted_2 = { class: "card-frame" }
const _hoisted_3 = { class: "buttons" }

import { computed, CSSProperties, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import QuestionCard from '@/components/QuestionCard.vue'
import ResultCard from '@/components/ResultCard.vue'
import CheckMark from './CheckMark.vue'
import ButtonText from './ButtonText.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const areButtonsDisabled = ref(true)
const fadeout = ref(false)
const fadein = ref(false)

const isYesFullBg = computed(() => store.state.swipeState === 'yes')
const isNoFullBg = computed(() => store.state.swipeState === 'no')
const buttonStyle = computed((): CSSProperties => {
  if (!areButtonsDisabled.value) {
    return {}
  }
  return { cursor: 'pointer', pointerEvents: 'none' }
})

const onClick = (isYes: boolean) => {
  if (areButtonsDisabled.value) {
    return
  }
  areButtonsDisabled.value = true
  store.commit(isYes ? 'clickYes' : 'clickNo')
}
store.subscribe((mutation) => {
  if (mutation.type === 'answer') {
    areButtonsDisabled.value = true
    fadeout.value = true
  }
})
store.subscribeAction((action) => {
  if (action.type === 'confirm') {
    fadein.value = true
    fadeout.value = false
    setTimeout(() => {
      areButtonsDisabled.value = false
      fadein.value = false
    }, 500)
  }
})
onMounted(() => {
  setTimeout(() => (areButtonsDisabled.value = false), 2000)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(QuestionCard),
      _createVNode(ResultCard)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["no button transButton", { fullBackground: _unref(isNoFullBg), fadeout: fadeout.value, fadein: fadein.value }]),
        style: _normalizeStyle(_unref(buttonStyle)),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick(false)))
      }, [
        _createVNode(CheckMark, { "is-tick": false }),
        _createVNode(ButtonText, { "is-yes": false })
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["yes button transButton", { fullBackground: _unref(isYesFullBg), fadeout: fadeout.value, fadein: fadein.value }]),
        style: _normalizeStyle(_unref(buttonStyle)),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick(true)))
      }, [
        _createVNode(CheckMark, { "is-tick": true }),
        _createVNode(ButtonText, { "is-yes": true })
      ], 6)
    ])
  ]))
}
}

})